
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import { afterLogin } from "../actions/users";
import { ajaxCaller, ajaxNonJsonCaller } from "../ajaxCaller";
import { saveToCookies } from "./helpers/utils";
// Styles
import 'react-select2-wrapper/css/select2.css';
import "../style.css";
import style from "./styles/Authentication.module.scss";
// Logo
import logo from "../img/petdesk-phones-bi-logo.png";

const Authentication = () => {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [authenticated, setAuthenticated] = useState(null);
  const [authenticationFailed, setAuthenticationFailed] = useState(null);
  const [authenticatedUser, setAuthenticatedUser] = useState(null);
  const [companies, setCompanies] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [passwordRecoveryEmail, setPasswordRecoveryEmail] = useState(null);
  const [showCompanySelection, setShowCompanySelection] = useState(false);
  // React Refs -----------------------------------------------------------------------------------------------------------------------------------------
  const modalRef = useRef(null);
  const [company, setCompany] = useState(null);

  const authenticateAdmin = (event) => {
    ajaxNonJsonCaller("User/SetCompanyForKontaAdmin?companyId=" + companyId, {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + authenticatedUser.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((response) => {
      if (!response.isError) {
        getCompany(authenticatedUser.token, () => {
          saveToCookies(authenticatedUser);
          if (!afterLogin(response)) {
            setAuthenticated(true);
          }
          setShowCompanySelection(false);
        });

      }
    });
  }

  const getCompany = (token, callback) => {
    ajaxCaller("Company/GetCurrentUserCompany/", {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    }).then((response) => {
      if (!response.isError) {
        Cookies.set("company_logo", response.logo);
        Cookies.set("companyKey", response.companyKey);
        Cookies.set("company_id", response.id);
        callback && callback();
      }
    });
  }

  const authenticateUser = () => {
    ajaxCaller("User/Authenticate", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    }).then((response) => {
      if (response.isError) {
        setAuthenticationFailed(true);
      } else {
        if (response.kontakAdmin) {
          setAuthenticatedUser(response);
          ajaxCaller("Company/GetAllCompaniesRet", {
            method: "get",
            headers: new Headers({
              Authorization: "Bearer " + response.token,
              "Content-Type": "application/json",
              Accept: "application/json",
            }),
          }).then((companies) => {
            setCompanies(companies);
            setShowCompanySelection(true);
          });
        } else {
          getCompany(response.token, () => {
            saveToCookies(response);
            if (!afterLogin(response)) {
              setAuthenticated(true);
            }
          });
        }
      }
    });
  }

  function onCompanySelected(event) {
    const company = event;
    setCompany(company);
    setCompanyId(company?.value);
  }

  useEffect(() => {
    if (authenticated) {
      window.location.href = "/dashboard";
    }
  });

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const [errorMessage, setErrorMessage] = useState(null);
  const [modalMessage, setModalMessage] = useState(null);

  const recoveryPassword = () => {
    const email = encodeURIComponent(passwordRecoveryEmail);
    ajaxCaller(`User/PasswordRecovery?email=${email}`, {
      method: "put",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(response => {
      if (response.isError) {
        setErrorMessage(response.message);
        setModalMessage(null);
      } else {
        setModalMessage("You have been sent an email to reset your password.");
        setEmail(null);
        setErrorMessage(null);
      }
    });
  }

  const isPasswordRecoveryDisabled = (email) => {
    if (typeof email !== 'string' && email !== null) {
      return true;
    }
    return email === null || email.trim() === "" || !validateEmail(email);
  };


  // Extracted components
  const ErrorMessages = ({ message }) => (
    <>
      {message && (
        <div className="alert alert-danger alert-error-modal">
          <span className="change-password-error">{message}</span>
        </div>
      )}
    </>
  );

  const SuccessMessage = ({ message }) => (
    <div className="alert alert-success alert-success-modal alert-success-bold">
      <span className="change-password-success">{message}</span>
    </div>
  );

  return (
    <>
      <div className="modal fade" id="modalForgotPass" tabIndex="-1" role="dialog" aria-labelledby="modalForgotPass" aria-hidden="true" ref={modalRef}>
        <div className="modal-dialog" role="document">
          <>
            {errorMessage ? (
              <ErrorMessages
                message={errorMessage}
              />
            ) : (
              modalMessage && <SuccessMessage message={modalMessage} />
            )}
          </>
          <div className="modal-content" style={{ borderRadius: '10px' }}>
            <div className="modal-body">
              <div className="container-fluid">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setErrorMessage(null);
                    setModalMessage(null);
                    setPasswordRecoveryEmail('');
                  }}
                >
                  <span aria-hidden="true"></span>
                </button>
                <div className="row justify-content-center">
                  <div className="col-12 text-center mt-4">
                    <h5 className="mb-4">
                      Please provide your email
                    </h5>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input type="email"
                        value={passwordRecoveryEmail || ''}
                        onChange={(event) => setPasswordRecoveryEmail(event.target.value)}
                        name="email-rec"
                        id="email-rec"
                        className="form-style small"
                        placeholder="Your Email..."
                        autoComplete="off" />
                    </div>
                  </div>
                  <div className={`${style.button_row}`}>
                    <button
                      onClick={() => recoveryPassword()}
                      disabled={isPasswordRecoveryDisabled(passwordRecoveryEmail)}
                      type="button"
                    >
                      Recovery Password
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id={style.login}>
        <div className={style.container}>
          <div className={style.row}>
            <div className={style.form_login}>
              <div className={`${style.form_row} ${style.header}`}>
                <div className={`${style.form_item} ${style.text_header_colored}`}>
                  <span>PETDESK PHONES ADMIN DASHBOARD</span>
                </div>
                <div className={`${style.form_item} ${style.logo_canvas}`}>
                  <img
                    src={logo}
                    alt="petdesk-logo"
                    width="814"
                    height="215"
                    style={{
                      width: "120%",
                      height: "auto",
                    }}
                  />
                </div>
                <div className={`${style.form_item} ${style.text_header}`}>
                  <h5>Please provide your email and password</h5>
                </div>
              </div>
              <div className={`${style.form_row} ${style.body}`}>
                {authenticationFailed && (<div className="alert alert-danger" role="alert">Check your email and password</div>)}
                <form onSubmit={(e) => authenticateUser(e)}>
                  <div className={`${style.form_item} ${style.fields}`}>
                    <div
                      className={`${style.form_subitem} ${style.email_field}`}
                    >
                      <input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="Your Email..."
                        autoComplete="off"
                        onKeyDown={(event) => {
                          var key = event;
                          if (key === 13 || key === 14) {
                            authenticateUser()
                          }
                        }}
                        onChange={(event) => setEmail(event.target.value)}
                      />
                    </div>
                    <div
                      className={`${style.form_subitem} ${style.password_field}`}
                    >
                      <input
                        type="password"
                        name="password"
                        id="password"
                        placeholder="Your Password..."
                        autoComplete="off"
                        onKeyDown={(event) => {
                          var key = event;
                          if (key === 13 || key === 14) {
                            authenticateUser()
                          }
                        }}
                        onChange={(event) => setPassword(event.target.value)}
                      />
                    </div>
                  </div>
                  <div
                    className={`${style.form_item} ${style.forgot_password_link}`}>
                    <p>
                      <a
                        href="/#"
                        data-toggle="modal"
                        data-target="#modalForgotPass"
                      >
                        Forgot password?
                      </a>
                    </p>
                  </div>
                  <div className={`${style.form_item} ${style.button_login}`}>
                    <button
                      type="button"
                      data-toggle="modal"
                      data-target="#modalSelectCompany"
                      onClick={authenticateUser}
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showCompanySelection}
          onHide={() => setShowCompanySelection(false)}
        >
          <div className="modal-body" style={{ borderRadius: '10px' }}>
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-12 text-center">
                  <h5 className="mb-4">Please select a company</h5>
                </div>
                <div className="col-12">
                  <div className="section z-bigger-20">
                    <CreatableSelect
                      className="input-select-style no-search bigger-text"
                      isClearable={true}
                      isDisabled={false}
                      isLoading={false}
                      isCreatable={false}
                      onChange={(event) => onCompanySelected(event)}
                      value={company}
                      defaultValue={company}
                      placeholder="Company..."
                      theme="bootstrap4"
                      options={
                        companies?.map((x) => {
                          const indicators = [
                            x.hasCalls && "📱",
                            x.hasLiveChats && "⌨",
                            x.isUncategorized && "❓"
                          ]
                            .filter(Boolean)
                            .join(" ");

                          return {
                            value: x.id,
                            label: `${x.name}${indicators ? ` ${indicators}` : ''}`
                          };
                        })
                      }
                      formatCreateLabel={() => undefined}
                      isValidNewOption={() => false}
                    />
                  </div>
                </div>
                <div className={`${style.button_row}`}>
                  <button
                    type="button"
                    onClick={authenticateAdmin}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Authentication;
